module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('only-container', [_c('only-loading', {
    attrs: {
      "loading": _vm.loading
    }
  }, [(!_vm.notExisted) ? _c('only-article', {
    staticClass: "animated",
    class: _vm.themeCfg.animated && _vm.themeCfg.animated.page,
    attrs: {
      "article": _vm.page,
      "config": _vm.config
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4fa53a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Page.vue
// module id = 177
// module chunks = 1